<template>
  <div class="down-resume-box" id="down-resume-box">
    <div class="down-card-list" v-show="isShowDownloadResume || libraryState">
      <template v-if="isShowDownloadResume">
        <div class="down-card-item" @click.stop="handleClickDownloadResume({type: 'pdf'})" data-growing-container
             data-growing-idx="1">
          <img src="https://files.wondercv.com/pc-vue/editor/download-pdf.png" alt="">
          <span>下载 PDF 文件</span>
        </div>
        <div class="down-card-item" @click.stop="handleClickDownloadResume({type: 'img'})" data-growing-container
             data-growing-idx="2">
          <img src="https://files.wondercv.com/pc-vue/editor/download-jpg.png" alt="">
          <span>下载 PNG 图片</span>
        </div>
      </template>
    </div>
    <div v-if="isShowDownloadResume" class="replace-style-item" @click="replaceStyle">
      <div class="btn">
        <img
          v-if="!isFirstRound"
          :class="{ 'rotate': isRotating }"
          src="https://logo.wondercv.com/banners/OBrlx8gZWiXHMr8.png"
          alt=""
        />
        {{ currentStyleIndex === 0 && isFirstRound ? '立即更换' : '换一换' }}
      </div>
    </div>
    <div class="down-resume-content"
         :style="{width: isShowDownloadResume ? '324px' : '0px', padding: isShowDownloadResume ? '24px' : '24px 0px'}">

      <!-- <h6 class="template-style-header">HR 推荐模板样式<img src="https://files.wondercv.com/pc-cvs/vip-icon.png" alt="">
      </h6>

      <div class="template-style-list">

        <div class="template-style-item"
             :class="{'active': cvDetail.format_info.template_type === 'default'}"
             @click="useTemplateStyleFun(activeTemplateStyle, 'default')">
          <img src="https://files.wondercv.com/PC/editor/editor_temp_00.png" alt="">
          <span>当前使用样式</span>
        </div>

        <div class="template-style-item"
             :class="{'active': cvDetail.format_info.template_type === item.imgSrc}"
             v-for="(item ,index) in tempStyleList"
             :key="index"
             @click="useTemplateStyleFun(item)">
          <img :src="item.imgSrc" alt="">
          <span>当前使用样式</span>
        </div>
      </div> -->

      <!-- <div class="title-box">
        <p class="title">选择下载简历类型</p>
      </div> -->


      <!-- 机构号入口 -->
      <!-- <div class="groups-entry-box" @click="showGroupsDialogFunc()" v-if="alertData.schoolName">
        <div class="groups-entry-left">
          <p class="groups-entry-left-title">
            <i class="iconfont iconcv-title-icon-edus"></i>
            「<span>{{ alertData.schoolName }}</span>」专属免费会员
          </p>
          <p class="groups-entry-left-subtitle">校友免费领取 30 天超级简历会员</p>
        </div>
        <i class="iconfont iconjinru"></i>
      </div> -->

      <!-- 插件入口  v-else-->
      <!-- <a class="plugin" href="/plugin" target="_blank">
        <img src="https://files.wondercv.com/PC/cvs/plugin-icon1.png" alt="" class="icon1">
        <img src="https://files.wondercv.com/PC/cvs/plugin-icon2.png" alt="" class="icon2">
        <div class="text">页面插件，一键网申</div>
        <span class="iconfont iconjinru"></span>
      </a> -->

      <div class="title-box">
        <p class="title">热招职位推荐</p>
        <div class="min-more-btn" @click="handleClickToMore">
          更多职位
        </div>
      </div>
      <div v-if="banner && banner.length">
        <a v-for="(item, index) in banner" :key="index" class="banner-box" :href="item.link" target="_blank"
           @click="clickBannerImage(item, $event)">
          <img :src="item.image">
        </a>
      </div>


      <template v-if="identity === 'student'">

        <div class="item-content" v-for="(item,index) in campusList" :key="index + '&campusCard'"
             @click="toCampusDetail(item.token)" data-growing-container :data-growing-idx="60 + index">

          <div class="category-info">
            <div class="content-img">
              <img :src="item.company_logo || item.company_logo_hr || 'https://files.wondercv.com/icon/Artboard.png'"
                   alt="">
            </div>
            <div class="content-infos">
              <p class="infos-comp">{{ item.company_name }}</p>
              <p class="infos-cate">
                <span>{{ item.category }}</span>
                <span>{{ item.city_names | cityFilter }}</span>
              </p>
            </div>
          </div>

          <div class="time">
            <i class="iconfont iconshijian"></i>
            <p class="infos-time">{{ recruitmentTime(item.comp_recruit_info) }}</p>
          </div>
        </div>

      </template>

      <template v-else>
        <cvJobCard cardType="download" :cardData="item" v-for="(item, index) in jobList"
                   :key="index + '&downloadJobCard'" data-growing-container :data-growing-idx="4 + index"/>
      </template>

    </div>
    <!-- <div v-if="isShowDownloadResume" class="more-btn">
      <div @click="handleClickToMore" data-growing-container data-growing-idx="3">查看更多职位</div>
    </div> -->
    <alert ref="recommendCvAlert" :alertData="alertData" @close="alertData.show = false"/>
  </div>
</template>

<script>
import {recruitmentTime, getBannerParams} from "@/assets/js/util"
import {mapMutations, mapState} from "vuex";
import api from '@/api';
import cvJobCard from './cvJobCard'
import moment from 'moment'
import {ioMixin} from '@/assets/js/io'
import {downloadToJob} from "@/api/list/recommend"
import alert from '@/views/cvs/components/alert'
import recommendTemplateStyle from '@/assets/json/recommend-template-style.json'
import {styleMixin} from '@/assets/js/mixins'


export default {
  name: "downResumeBox",
  computed: {
    ...mapState('editor', ['activeTemplateStyle', 'groupsEntryData', 'isShowDownloadResume', 'cvDetail', 'editorHelperPopup', 'libraryState', 'profile', 'cvToken']),

    isMentorEditor() {
      return window.location.href.includes('mentor')
    }
  },
  components: {
    cvJobCard,
    alert
  },
  mixins: [ioMixin, styleMixin],
  data() {
    return {
      moment,
      identity: '',
      banner: [],
      jobList: [],
      campusList: [],
      alertData: {
        show: false,
        type: 'groups'
      },
      tempStyleList: recommendTemplateStyle.download,
      isShowCvHeaderLine: false
    }
  },
  created() {
    this.getIdentity()
    this.getBanner()
    this.getJobList()
    this.getCampusList()
    // 获取机构号数据
    // this.getGroupsEntryInfo()
  },
  filters: {
    cityFilter(val) {
      if (val && val.length) {
        let cityStr = ''
        val.forEach((item, index) => {
          if (index < 2) cityStr += `${item}、`
        })
        return val.length > 2 ? cityStr.slice(0, -1) + '等' : cityStr.slice(0, -1)
      } else {
        return '全国'
      }

    }
  },
  methods: {
    recruitmentTime,
    ...mapMutations('editor', ['setEditorHelperPopup', 'setProfileData', 'setOldLineHeight', 'setCvDetail', 'setBackUpProfile', 'setBackUpFormatInfo']),

    useTemplateStyleFun(item, val) {
      // 基本信息
      this.selectInfo(item.show_attr_name)
      // 布局
      this.setFormatInfo({head_format: item.head_format})
      // 顶部
      this.setCvHeaderLineShow(item.top_format, item.top_format === 'line', true)
      // 标题样式
      this.changeTileFormat(item.title_format)
      // 主题色
      this.setFormatInfo({title_select_color: false, title_color: item.title_color})
      // 模版类型
      this.setFormatInfo({template_type: val || item.imgSrc})
    },
    // 切换简历 标题样式（类型）
    changeTileFormat(type) {
      this.setFormatInfo({title_format: type})
      // 如果选择了图标标题，并且这个时候标题颜色选择的自定义颜色，因为图标标题没有自定义颜色选项，所以需要把标题颜色重置为默认值
      if (type === 'icon' && this.cvDetail.format_info.title_select_color) {
        this.setFormatInfo({title_select_color: false, title_color: '#000000'})
      }
    },
    // 设置 顶部线条 显示
    setCvHeaderLineShow(type, flag, isTemplateStyle) {
      this.isShowCvHeaderLine = flag
      if (isTemplateStyle) {
        this.setFormatInfo({top_format: type})
      } else {
        this.setFormatInfo({top_format: type, template_type: null})
      }
    },
    // 切换是否显示信息名称
    async selectInfo(value) {
      this.profile.show_attr_name = value
      //修改基本信息设置
      this.setProfileData({...this.profile})
      try {
        //检测是否有profile数据
        if (this.profile.id) {
          let res = await api.cvsEditor.editProfile(this.cvToken, this.profile);
          if (res.code === 1000) {
          } else {
            this.$message.success(res.message)
          }
        }

      } catch (error) {

      }
    },
    //更改format_info
    setFormatInfo(options) {
      //当前模块要有 key，value
      let cvDetail = JSON.parse(JSON.stringify(this.cvDetail))
      //同步数据
      Object.keys(options).forEach(key => {
        cvDetail.format_info[key] = options[key]
        if (key === 'line_spacing') {
          //保存行距
          this.setOldLineHeight(options[key])
        }
      })
      //同步到vuex中
      this.setCvDetail(cvDetail)

      //触发保存
      this.submit()
    },
    // 保存
    async submit() {
      let {kind} = this.cvDetail.basic_info
      if (kind === 'template' || kind === 'sample') {
        // this.$message.success('保存成功')
        //修改基本信息备份基本信息设置
        this.setBackUpProfile(JSON.parse(JSON.stringify(this.profile)))
        //修改简历设置备份
        this.setBackUpFormatInfo(JSON.parse(JSON.stringify(this.cvDetail.format_info)))
        return false
      }
      try {
        let data = {
          operation_type: 'update_format_info',
          format_info: this.cvDetail.format_info
        }
        let res = {}
        if (this.isMentorEditor) {
          res = await api.cvsEditor.updatedMentorCvInfo(this.cvToken, data)
        } else {
          res = await api.cvsEditor.updatedCvInfo(this.cvToken, data);
        }
        if (res.code === 1000) {
          //修改基本信息备份基本信息设置
          this.setBackUpProfile(JSON.parse(JSON.stringify(this.profile)))
          //修改简历设置备份
          this.setBackUpFormatInfo(JSON.parse(JSON.stringify(this.cvDetail.format_info)))
          //当前右侧大tab选择类型置为空
        } else {
          this.$message.success(res.message)
        }
      } catch (error) {
        this.$message.success('修改失败')
      }
    },
    showGroupsDialogFunc() {
      this.alertData.show = true
    },
    async getGroupsEntryInfo() {
      try {
        let params = {
          type: 'download'
        }
        let res = await api.account.getUserEntrance(params)
        if (res.code === 1000) {
          this.alertData = {
            show: false,
            type: 'groups',
            groupToken: res.data.group_token,
            schoolName: res.data.school_name,
            schoolLogo: res.data.school_logo
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 获取用户身份
    async getIdentity() {
      try {
        let res = await api.cvsV2.getIdentifyInfo(this._c_t)
        if (res.code === 1000) {
          this.identity = res.data.status
          api.cvsV2.getCampusStatus({config_name: 'comp_recruit'}).then(ress => {
            if (ress.code == 1000 && ress.data.status == 'false') {
              this.identity = 'already_work'
            }
          })

        }
      } catch (e) {
        console.log(e)
      }
    },
    async getCampusList() {
      try {
        let params = {
          page: 1,
          size: 9,
          info_type: '不限',
          type: 'recommend',
        }
        let res = await api.jobs.get_recruit_list(params)
        if (res.code === 1000) {
          this.campusList = res.data.comp_recruit_infos || []
        }
      } catch (e) {
        console.log(e)
      }
    },
    handleClickDownloadResume(params) {
      // if(this.cvDetail.basic_info.lang === 'cn'){
      //   api.planning.getExperience(this.$route.params.token).then(res=>{
      //     if(res.code === 1000 && (res.data.edus.length > 0 || res.data.works.length > 0)){
      //       window.open(`/planning/${this.$route.params.token}/index`, '_blank')
      //     }
      //   })
      // }
      this.$eventBus.$emit('download', params)
    },
    async getBanner() {
      // banner
      try {
        let banner = []
        const [res1, res2] = await Promise.all([
          api.jobs.getV4Banner(getBannerParams(136)),
          api.jobs.getV4Banner(getBannerParams(137))
        ])
        if (res1.code === 1000 && res1.data && res1.data.length) {
          banner.push(res1.data[0])
        }
        if (res2.code === 1000 && res2.data && res2.data.length) {
          banner.push(res2.data[0])
        }
        this.banner = banner;
      } catch (error) {
        console.log(error);
      }
    },
    async getJobList() {
      let [res1, res2, res3] = await Promise.all([
        // api.cvsV2.cvsDownloadJobsRecommend({size: 9, page: 1, cv_token: this.$route.params.token}),
        api.recommend.downloadToJob({
          size: 9,
          page: 1,
          resume_token: this.$route.params.token,
          cv_account_token: this.accountToken.c_t || ''
        }),
        api.cvsV2.cvsJobsRecommend({
          size: 9,
          from: 0,
          jd_flag: 1,
          resume_token: this.$route.params.token,
          resume_flag: 1
        }),
        api.jobs.companyListUnlogin({from: 0, size: 9})
      ])
      if (res1.code === 1000 || res2.code === 1000 || res3.code === 1000) {
        this.jobList = (res1 && res1.data && res1.data.jobs.length > 0 && res1.data.jobs) || (res2 && res2.data && res2.data.jobs.length > 0 && res2.data.jobs) || (res3 && res3.data && res3.data.jobs.length > 0 && res3.data.jobs) || []

        // 同步是否显示小助手发的推荐职位
        if (res2.code === 1000 && res2.data.jobs.length) {
          this.setEditorHelperPopup({
            ...this.editorHelperPopup,
            recommendJobItem: res2.data.jobs[0]
          })
        }
      }
    },
    //跳转详情页
    toCampusDetail(token) {
      window.open(`/comp_recruit_infos/${token}`, '_blank')
    },
    handleClickToDetail(data) {
      window.open(`/jobs/${data.token}.html`, '_blank')
    },
    handleClickToMore() {
      if (this.identity === 'student') {
        window.open('/campus_recruiting/user_show', '_blank')
      } else {
        window.open('/jobs/recommend', '_blank')
      }
    },
    // 点击广告位
    clickBannerImage(bannerData, event) {
      const {job_infos = [], deliver_channel, link} = bannerData;
      if (deliver_channel) {
        let jobToken = job_infos.length ? job_infos[0].token : '';
        this.$store.dispatch('app/setAlertData', {
          show: true,
          type: 'aliJobDelivery',
          deliveryJobOptions: {
            jobToken: jobToken,
            title: bannerData.title
          },
          isDarkTheme: true
        });
        // 阻止默认跳转
        event.preventDefault()
        return
      }

      // 升级会员弹窗
      if (link.startsWith('https://buymember#')) {
        const [, dialogMemberConfigStr] = link.split('#');
        this.$store.dispatch('app/setAlertData', {
          show: true,
          type: 'upVip',
          dialogMemberConfigStr
        });
      } else if (link) {
        // 其他外链跳转
        window.open(link, '_blank');
      }
    }
  },
  watch: {
    groupsEntryData: {
      handler() {
        if (this.groupsEntryData.code === 1000) {
          this.alertData = {
            show: false,
            type: 'groups',
            groupToken: this.groupsEntryData.data.group_token,
            schoolName: this.groupsEntryData.data.school_name,
            schoolLogo: this.groupsEntryData.data.school_logo
          }
        } else {
          this.alertData = {
            show: false,
            type: 'groups',
            groupToken: '',
            schoolName: '',
            schoolLogo: ''
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">

.down-card-list {
  width: 324px;
  margin-left: 16px;
  // display: flex;
  // justify-content: space-between;
  margin-bottom: 10px;

  .down-card-item {
    width: 100%;
    height: 48px;
    box-shadow: 0px 1px 10px 0px rgba(3, 47, 129, 0.01);
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 16px;

    &:first-of-type {
      background: linear-gradient(180deg, #FF9368 0%, #FF6644 100%);

      &:hover {
        opacity: 0.8;
        // background: #FF8569;
      }
    }

    &:last-of-type {
      background: linear-gradient(180deg, #6FA1FF 0%, #80B1F2 0%, #2E76FF 100%);

      &:hover {
        opacity: 0.8;
        // background: #669BFF;
      }
    }

    & > img {
      width: 17px;
      margin-right: 10px;
    }

    .iconfont {

      font-size: 22px;

      &.iconpdf {
        color: #ff5562;
      }

      &.iconjpg {
        color: #4183FF;
      }
    }

    &:hover {
      box-shadow: 0px 2px 16px 0px rgba(10, 44, 156, 0.1);;
    }
  }
}

.replace-style-item {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 324px;
  height: 60px;
  background-image: url('https://logo.wondercv.com/banners/8xnnTMe73zRQkaC.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-bottom: 16px;
  margin-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 76px;
    height: 28px;
    border-radius: 100px;
    font-size: 11px;
    color: #ff6644;
    background-color: #fff;
    font-weight: 600;
    cursor: pointer;

    img {
      width: 10px;
      height: 10px;
      margin-right: 4px;
      transition: transform 0.3s;

      &.rotate {
        animation: rotate 0.3s forwards;
      }
    }
  }
}

.down-resume-box {
  position: relative;
  // max-height: 1020px;
  height: auto;
}

.down-resume-content {
  // height: calc(100% - 198px);
  height: calc(100% - 128px);
  background: #F8F9FD;
  border-radius: 4px 4px 0 0;
  margin-left: 16px;
  padding: 24px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  transition: all 0s linear !important;
  box-sizing: border-box;

  .template-style-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #404040;
    line-height: 22px;
    margin-bottom: 4px;

    > img {
      width: 26px;
      margin-left: 6px;
    }
  }

  .template-style-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .template-style-item {
      position: relative;
      cursor: pointer;
      margin-top: 12px;
      width: 132px;
      height: 186px;
      box-sizing: border-box;
      border: 2px solid #fff;
      border-radius: 6px;

      > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
        border-radius: 6px;
      }

      > span {
        display: none;
        position: absolute;
        left: 50%;
        bottom: 9px;
        transform: translateX(-50%);
        width: calc(100% - 18px);
        height: 34px;
        background: rgba(65, 131, 255, 0.9);
        font-size: 12px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 12px;
        text-align: center;
        border-radius: 4px;
        line-height: 34px;
      }

      &.active {
        border-color: #4183FF;

        > span {
          display: block;
        }
      }

      &:hover {
        border-color: #4183FF;
      }
    }
  }

  .title-box {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 16px;
      font-weight: 500;
      color: #404040;
      line-height: 22px;
    }

    .min-more-btn {
      width: 76px;
      height: 24px;
      border-radius: 12px;
      border: 1px solid #ECECEC;
      text-align: center;
      line-height: 24px;
      font-size: 13px;
      font-weight: 400;
      color: #606060;
      cursor: pointer;
    }
  }

  .plugin {
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(5, 13, 48, 0.02);
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px 0 14px;
    position: relative;
    cursor: pointer;
    margin-bottom: 26px;

    .text {
      flex: 1;
      margin-left: 9px;
      font-size: 14px;
      color: #404040;
    }

    .icon1 {
      width: 28px;
      height: 28px;
    }

    .icon2 {
      position: absolute;
      bottom: 0;
      right: 38px;
      width: 60px;
    }

    .iconfont {
      background: #F4F4F4;
      width: 18px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      font-size: 14px;
      border-radius: 50%;
      color: #BCBCBC;
      box-sizing: border-box;
      padding-left: 1px;
    }

    &:hover {
      .iconfont {
        background-color: #ECECEC;
      }
    }
  }

  .groups-entry-box {
    display: flex;
    align-items: center;
    padding: 14px 11px 14px 14px;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(5, 13, 48, 0.02);
    border-radius: 6px;
    margin-bottom: 26px;
    cursor: pointer;

    .groups-entry-left {
      flex: 1;

      .groups-entry-left-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        color: #404040;
        line-height: 20px;
        margin-bottom: 2px;

        .iconcv-title-icon-edus {
          font-size: 16px;
          color: #4183FF;
        }

        > span {
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .groups-entry-left-subtitle {
        font-size: 12px;
        font-weight: 400;
        color: #9C9C9C;
        line-height: 17px;
        padding-left: 24px;
      }
    }

    .iconjinru {
      color: #CFCFCF;
      font-size: 12px;
    }
  }

  .banner-box {
    display: block;
    width: 276px;
    height: 105px;

    & > img {
      width: 100%;
      height: 100%;
      box-shadow: 0px 1px 10px 0px rgba(3, 47, 129, 0.01);
      border-radius: 6px;
      object-fit: cover;
    }

    &:nth-child(2) {
      margin-top: 10px;
    }
  }

  .item-content {
    margin-top: 10px;
    background-color: #ffffff;
    cursor: pointer;
    padding: 16px 16px 12px;
    box-sizing: border-box;
    border-radius: 6px;

    &:hover {
      box-shadow: 0px 2px 16px 0px rgba(10, 44, 156, 0.1);
    }

    .category-info {
      display: flex;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px dashed #ececec;

      .content-img {
        display: flex;
        align-items: center;
        width: 44px;
        height: 44px;
        border-radius: 2px;
        border: 1px solid #ECECEC;
        margin-right: 8px;

        > img {
          width: 100%;
        }
      }

      .content-infos {

        > p {
          max-width: 190px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .infos-comp {
          font-size: 14px;
          font-weight: 500;
          color: #404040;
          line-height: 14px;
          margin-bottom: 9px;
        }

        .infos-cate {
          position: relative;
          font-size: 12px;
          font-weight: 400;
          color: #9C9C9C;
          line-height: 14px;

          > span {
            position: relative;
            margin-right: 13px;

            &::after {
              content: "";
              position: absolute;
              top: 3px;
              right: -8px;
              width: 1px;
              height: 10px;
              background: #ECECEC;
            }

            &:last-of-type {
              margin-right: 0;

              &::after {
                display: none;
              }
            }
          }

        }
      }
    }


    .time {
      margin-top: 9px;
      display: flex;
      align-items: center;
      height: 26px;
      background: #F9F9F9;
      border-radius: 14px;


      > i {
        font-size: 14px;
        color: #ff6644;
        margin-left: 8px;
        margin-right: 6px;
      }

      > p {
        font-size: 12px;
        font-weight: 400;
        color: #404040;
        line-height: 12px;
      }
    }

  }

  .job-item-box {
    cursor: pointer;
    background: #FFFFFF;
    box-shadow: 0px 1px 10px 0px rgba(3, 47, 129, 0.01);
    border-radius: 6px;
    margin-top: 10px;
    padding: 16px 16px 13px 16px;
    box-sizing: border-box;

    .job-base {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 6px;

      .job-title {
        font-size: 14px;
        font-weight: 500;
        color: #404040;
        line-height: 20px;
      }

      .job-salary {
        font-size: 14px;
        font-weight: 600;
        color: #FF6644;
        line-height: 20px;
      }
    }

    .job-info {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;
      max-width: 244px;
      height: 21px;
      overflow: hidden;

      & > span {
        padding: 2px 6px;
        margin-right: 6px;
        background: rgba(31, 80, 171, 0.03);
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 17px;
      }
    }

    .company-info {
      display: flex;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px dotted #ECECEC;
      margin-bottom: 9px;

      & > .job-company-logo {
        width: 24px;
        height: 24px;
        border-radius: 2px;
        border: 1px solid #ECECEC;
        margin-right: 2px;
      }

      & > span {
        padding: 0 6px;
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        line-height: 14px;
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        &::after {
          content: "";
          height: 9px;
          width: 1px;
          background-color: #cfcfcf;
          position: absolute;
          right: 0;
          top: 3px
        }

        &:last-child::after {
          display: none;
        }
      }
    }

    .matching {
      display: flex;
      align-items: center;

      .icon {
        width: 13px;
        height: 13px;
        background: #FF8569;
        border-radius: 2px;
        font-size: 11px;
        line-height: 13px;
        text-align: center;
        color: #fff;
        margin-right: 6px;
      }

      .content {
        font-size: 12px;
        font-weight: 400;
        color: #9C9C9C;
        line-height: 17px;
      }
    }

    &:hover {
      box-shadow: 0px 2px 16px 0px rgba(10, 44, 156, 0.1);
    }
  }
}

.more-btn {
  position: absolute;
  left: 16px;
  bottom: 0;
  width: 324px;
  background: #ffffff;
  padding: 12px 24px 20px;
  box-sizing: border-box;
  box-shadow: 0px -8px 20px 0px rgba(36, 76, 150, 0.03);
  border-radius: 0 0 4px 4px;

  > div {
    cursor: pointer;
    height: 40px;
    line-height: 40px;
    background: #ff6644;
    border-radius: 20px;
    text-align: center;

    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    letter-spacing: 1px;

    &:hover {
      background: #FF8569;
    }

  }

}
</style>
